<div
  id="homestyleGrid"
  #homestyleGrid
  class="kendo-container"
  kendoTooltip
  showOn="none"
  [tooltipTemplate]="template"
  filter=".k-grid td"
  (mouseover)="showTooltip($event)"
  mdm
>
 <kendo-contextmenu
      #gridmenu
      [kendoMenuHierarchyBinding]="menuItems"
      [textField]="['text', 'childText']"
      childrenField="children"
      svgIconField="svgIcon"
      separatorField="separator"
      (select)="onSelect($event)"
      (close)="onContextMenuClose()"
    ></kendo-contextmenu>

 <kendo-grid #grid
             [resizable]="true"
             [kendoGridBinding]="gridData"
             [sortable]="true"
             [sort]="sort"
             (selectionChange)="OnSelectionChangeEvent($event)"
             [group]="group"
             [groupable]="{
      enabled: true,
      emptyText: 'Drag and Drop columns here to create Groups.',
      showFooter: true,
    }"
             (groupChange)="groupChange($event)"
             [style.maxHeight.px]="600"
             filterable="menu, row"
             [filter]="gridFilter"
             [skip]="skip"
             [pageable]="true"            
             [pageSize]="pageSize"
             (pageChange)="onPageChange($event)"
             [reorderable]="true"
             [selectable]="{ enabled: true, checkboxOnly: true }"
             [kendoGridSelectBy]="'changeRequestId'"
             [selectedKeys]="selectedKeys"
             (cellClick)="onCellClick($event)"
             [trackBy]="trackByFn"
             (dataStateChange)="onDataStateChange($event)">
   <ng-template kendoGridToolbarTemplate class="toolbarButton">
     <div class="RequestHeader">
       <div class="RequestButtons">
         <div class="ButtonLeft">
           <kendo-autocomplete [filterable]="true"
                               [data]="userList"
                               class="assigntext"
                               placeholder="Users: Type or double-click"
                               id="userSelected"
                               valueField="name"
                               [value]="selectedUser"
                               (valueChange)="onUserValueChange($event)"
                               (filterChange)="userFilterChange($event)"
                               [ngClass]="roleSpecialist ? '' : 'disabled'"
                               #autoComplete
                               (dblclick)="onDoubleClick(autoComplete)">
           </kendo-autocomplete>
           <button class="ExportButton assignButton"
                   *ngIf="roleSpecialist"
                   [ngClass]="{
                'export-btn-disabled':
                  selectedIds.size == 0 || AssignUserId == 0
              }"
                   (click)="assignButton()">
             Assign
           </button>
           <button class="ExportButton"
                   *ngIf="roleSpecialist"
                   [ngClass]="roleSpecialist ? '' : 'disabled'"
                   (click)="generateLoadFiles()">
             Generate Load Files
           </button>

           <button (click)="onClickExport($event)" class="ExportButton">
             Export for Review
           </button>
         </div>

         <div class="ButtonRight">
           <button class="ExportButton" (click)="onClickMyRequests()">
             My Requests
           </button>
           <button class="ExportButton" (click)="onClickNewRequests()">
             New Requests
           </button>
           <button class="ExportButton" (click)="onClickAllRequests()">
             All Requests
           </button>
           <button class="ExportButton" (click)="onClickClearAll()">
             Clear All Filter
           </button>
         </div>
       </div>
       <kendo-excelexport #excelExport (workbookReady)="onExcelDownload()">
         <kendo-excelexport-column field="changeRequestId"
                                   title="ID"></kendo-excelexport-column>
         <kendo-excelexport-column field="description"
                                   title="Description"
                                   [width]="150"></kendo-excelexport-column>
         <kendo-excelexport-column field="justification"
                                   title="justification"
                                   [width]="150"></kendo-excelexport-column>
         <kendo-excelexport-column field="statusLabel"
                                   title="status"></kendo-excelexport-column>
         <kendo-excelexport-column field="assignedTo"
                                   title="assignedto"></kendo-excelexport-column>
         <kendo-excelexport-column field="dueDate"
                                   title="dueDate"></kendo-excelexport-column>
         <kendo-excelexport-column field="dueInDays"
                                   title="dueInDays"></kendo-excelexport-column>
         <kendo-excelexport-column field="priorityLabel"
                                   title="priority"></kendo-excelexport-column>
         <kendo-excelexport-column field="facilityName"
                                   title="facility"></kendo-excelexport-column>
         <kendo-excelexport-column field="requestorName"
                                   title="requestor"></kendo-excelexport-column>
         <kendo-excelexport-column field="submissionDate"
                                   title="submitDate"></kendo-excelexport-column>
         <kendo-excelexport-column field="hasBuildItems"
                                   title="build"></kendo-excelexport-column>
         <kendo-excelexport-column field="closedDate"
                                   title="closedDate"></kendo-excelexport-column>
         <kendo-excelexport-column field="createdDate"
                                   title="createdDate"></kendo-excelexport-column>
         <kendo-excelexport-column field="mocDueDate"
                                   title="mocDueDate"></kendo-excelexport-column>
         <kendo-excelexport-column field="ferrMoC"
                                   title="ferrMoC"></kendo-excelexport-column>
         <kendo-excelexport-column field="onBehalfOfName"
                                   title="onBehalfOf"></kendo-excelexport-column>
       </kendo-excelexport>
     </div>
   </ng-template>

   <kendo-grid-checkbox-column [width]="45"
                               [headerClass]="{ 'text-center': true }"
                               class="Checkbox"
                               [resizable]="false"
                               [columnMenu]="true"
                               [showSelectAll]="true"
                               id="my-grid"
                               [columnMenu]="false"></kendo-grid-checkbox-column>
      
   <kendo-grid-column field="changeRequestId" title="CR #" [width]="160">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
     <ng-template kendoGridCellTemplate let-dataItem>
       <div class="link">
         <a [href]="getHref(dataItem)"
            (click)="OnCRClick($event)"
            target="_blank"
            [attr.data-value]="dataItem.changeRequestId">{{ dataItem.changeRequestId }}</a>
       </div>
     </ng-template>
   </kendo-grid-column>


   <kendo-grid-column field="description" title="Description"
                      [width]="150" class="align-left"
                      headerClass="align-left">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>

   <ng-template kendoGridNoRecordsTemplate>
     <ng-container>
       <span href="#" class="norecords">No records available</span>.
     </ng-container>
   </ng-template>
   <kendo-grid-column field="justification"
                      title="Justification"
                      [width]="150"
                      [minResizableWidth]="120"
                      class="align-left"
                      headerClass="align-left"
                      [filterable]="true">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>
   <kendo-grid-column field="statusLabel" title="Status"
                      [width]="130" filter="text"
                      filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
     <ng-template kendoGridCellTemplate let-dataItem>
       <div class="link">
         <span #spanList>
           <a (click)="openPopup(spanList, dataItem.changeRequestId)"
              [attr.data-value]="dataItem.changeRequestId">{{ dataItem.statusLabel }}</a>
         </span>
       </div>
     </ng-template>
   </kendo-grid-column>
   <kendo-grid-column field="assignedTo"
                      title="Assigned To"
                      [width]="150"
                      [minResizableWidth]="120"
                      class="align-left"
                      headerClass="align-left"
                      [filterable]="true"
                      filter="text"
                      filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.assignedTo }}
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="dueInDays" title="Due In (Days)" [width]="140" filter="numeric" filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>
   <kendo-grid-column field="priorityLabel" title="Priority" [width]="116" filter="text" filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>
   <kendo-grid-column field="facilityName" title="Facility" [width]="160" filter="text" filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>
   <kendo-grid-column field="requestorName" title="Requestor" [width]="140" filter="text" filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="submissionDate"
                      title="Submit Date"
                      [width]="200"
                      filter="date">
     
     <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-date-filter-cell [column]="column"
                                    [filter]="filter"
                                    [format]="'dd-MM-yyyy'"
                                    placeholder="dd-MM-yyyy">
       </kendo-grid-date-filter-cell>
     </ng-template>

     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.submissionDate | date:'dd-MM-yyyy' }}
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="dueDate"
                      title="Due Date"
                      [width]="200"
                      filter="date">
     
     <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-date-filter-cell [column]="column"
                                    [filter]="filter"
                                    [format]="'dd-MM-yyyy'"
                                    placeholder="dd-MM-yyyy">
       </kendo-grid-date-filter-cell>
     </ng-template>

     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.dueDate | date:'dd-MM-yyyy' }}
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="hasBuildItems"
                      title="Build"
                      [width]="100"
                      class="BuildClass"
                      filter="boolean">
     <ng-template kendoGridCellTemplate let-dataItem>
       <div class="buildColor" *ngIf="dataItem.hasBuildItems">
         <fa-icon [icon]="iconPack.FACHECK" class="btnSize"></fa-icon>
       </div>
       <div class="buildWhite" *ngIf="!dataItem.hasBuildItems">
         <fa-icon [icon]="iconPack.FAMINUSSQUARE" class="btnSize"></fa-icon>
       </div>
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="closedDate"
                      title="Closed Date"
                      [width]="200"
                      filter="date">
     
     <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-date-filter-cell [column]="column"
                                    [filter]="filter"
                                    [format]="'dd-MM-yyyy'"
                                    placeholder="dd-MM-yyyy">
       </kendo-grid-date-filter-cell>
     </ng-template>

     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.closedDate | date:'dd-MM-yyyy' }}
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="createdDate" title="Created Date" [width]="200"
                      filter="date">
     
     <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-date-filter-cell [column]="column"
                                    [filter]="filter"
                                    [format]="'dd-MM-yyyy'"
                                    placeholder="dd-MM-yyyy">
       </kendo-grid-date-filter-cell>
     </ng-template>

     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.createdDate | date:'dd-MM-yyyy' }}
     </ng-template>

   </kendo-grid-column>

   <kendo-grid-column field="mocDueDate"
                      title="MOC Due Date"
                      [width]="200"
                      filter="date">     
     <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-date-filter-cell [column]="column"
                                    [filter]="filter"
                                    [format]="'dd-MM-yyyy'"
                                    placeholder="dd-MM-yyyy">
       </kendo-grid-date-filter-cell>
     </ng-template>

     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.mocDueDate | date:'dd-MM-yyyy' }}
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="ferrMoc"
                      title="FERR MOC"
                      [width]="120"
                      filter="text"
                      filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
     <ng-template kendoGridCellTemplate let-dataItem>
       {{ dataItem.ferrMoc }}
     </ng-template>
   </kendo-grid-column>

   <kendo-grid-column field="onBehalfOfName" title="On Behalf Of" [width]="160" filter="text" filterVariant="multiCheckbox">
     <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
       <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
         <kendo-filter-contains-operator></kendo-filter-contains-operator>
         <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
         <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
         <kendo-filter-eq-operator></kendo-filter-eq-operator>
         <kendo-filter-neq-operator>Is not equal to</kendo-filter-neq-operator>
         <kendo-filter-isempty-operator>(nothing)</kendo-filter-isempty-operator>
       </kendo-grid-string-filter-cell>
     </ng-template>
   </kendo-grid-column>

 </kendo-grid>
</div>

<kendo-popup [anchor]="anchorElement" [animate]="true" *ngIf="show">
  <div class="popupDialog">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle"
        >Change Request {{ this.commentHistoryId }} Status History
      </span>
      <div href="#" class="popupClose" role="button" tabindex="0">
        <fa-icon
          [icon]="closeIcon"
          (click)="closePopup()"
          class="popupCLoseIcon"
        ></fa-icon>
      </div>
    </div>
    <div>
      <div class="popupContent">
        <kendo-grid [kendoGridBinding]="commentsHistory" [scrollable]="'none'"
    [resizable]="true" >
          <kendo-grid-column
            field="status"
            [width]="100"
            title="Status"
          ></kendo-grid-column>
          <kendo-grid-column
            field="submittedDateTime"
            title="Date & Time"
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>{{
                dataItem.submittedDateTime | date : "dd-MM-yyyy HH:mm:ss"
              }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="changedBy"
            title="Changed By"
            [width]="100"
          ></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </div>
</kendo-popup>

<ng-template #template let-anchor>
  <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
